import compose from 'lodash/fp/compose';
import { join } from 'path';

import { paginate, searchable, uploadable } from '../plugins';
import PluggableModule from '../pluggable';

const images = new PluggableModule('image');

images.extend({
  namespaced: true
});

const hop = compose(
  paginate('images', {
    pageSize: 20,
    filterDefinition: {
      uploadedAt: 'orderBy',
      type: '=='
    },
    filterDefault: {
      uploadedAt: 'desc'
    }
  }),
  searchable(),
  uploadable(
    '',
    ({ type, pathPrefix, file }) =>
      join(
        'adminUploads',
        type == 'POSTER' ? 'posters' : '',
        pathPrefix,
        file.name
      ),
    ({ tags }) => {
      return {
        customMetadata: {
          tags: tags.join(',')
        }
      };
    }
  )
);

export default hop(images);
